/**
 * Prefill payload for Add Contact opened from CareFlow no-match search (CAR-2831).
 * Fields are editable — unlike Patient 360 `initialPhoneNumber` lock.
 */
export type ContactSearchPrefill = {
  phoneNumber?: string;
  patientName?: string;
};

/**
 * Classify a raw search query into a coarse, non-PHI bucket for analytics.
 * Never emit the raw query — only this bucket leaves the browser.
 */
export function inferSearchType(query: string): string {
  const q = query.trim();
  if (!q) return "unknown";
  if (/^[+\d][\d\s-]{5,}$/.test(q)) return "phone";
  if (q.startsWith("#") || /uhid/i.test(q)) return "uhid";
  return "name";
}

/** Map a CareFlow search string to editable Add Contact prefill fields. */
export function deriveContactPrefillFromSearchQuery(
  query: string
): ContactSearchPrefill {
  const q = query.trim();
  if (!q) return {};

  const type = inferSearchType(q);
  if (type === "phone") {
    const digits = q.replace(/\D/g, "");
    return digits ? { phoneNumber: digits } : {};
  }
  if (type === "name") {
    return { patientName: q };
  }
  return {};
}
